// extracted by mini-css-extract-plugin
export default {"PostMenuTrigger":"py_a big_i big_j big_q big_vt big_xl big_et"};